import ImageCard from "./../Card/ImageCard";
import TextCard from "./../Card/TextCard";

import "./CardSelect.scss";

function CardSelect(props) {

    return (
        <div className="card cardsDos cardsTres cardsCuatro cardsOcho" key={props.keyID} data-value={props.dataValue}
             data-atributo={props.attribute} onClick={props.function}>
            <div className="card-body">
                <TextCard textCard={props.textCard}/>
            </div>
            <ImageCard className="card-img-top" src={props.src} alt={props.alt}/>
        </div>
    )
}

export default CardSelect;